module.exports = __webpack_public_path__ + "images/graphic-header-mobile-2@2x_5e2844a2cd2704307094ac0b813f010d.png";